import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDashboardContext } from '../components/Context/DashboardContext';
import { startSignalRConnection } from "../services/signalRService";
import { TranslationContext } from '../components/Context/TranslationContext';

const HeaderEmployee = () => {
    const { translations, language, setLanguage, isRTL } = useContext(TranslationContext);
    const navigate = useNavigate();
    const didFetch = React.useRef(false);
    const { profile, profileData } = useDashboardContext();
    const [isToggled, setIsToggled] = useState(false);
    
    const handleSignout = () => {
        // Clear user data from localStorage or context
        localStorage.removeItem('token');
        localStorage.removeItem('userType');
        localStorage.removeItem('userId');
        localStorage.removeItem('branchId');
        // Navigate to login page
        navigate('/login');
    };
    
    const getData = async (token) => {
        await profile();
    }
    
    const toggleLanguage = () => {
        setLanguage(language === 'en' ? 'ar' : 'en');
        localStorage.setItem("lang", language === 'en' ? 'ar' : 'en');
        const newLanguage = isRTL === true ? "rtl" : "ltr";
        document.documentElement.dir = newLanguage;
    };

    React.useEffect(() => {       
        if (!didFetch.current) {
            getData();
            didFetch.current = true;
        }
        startSignalRConnection();
        const body = document.body;

        if (isToggled) {
            body.classList.add('toggle-sidebar');
        } else {
            body.classList.remove('toggle-sidebar');
        }
    }, [isToggled]);

    const handleToggleSidebar = () => {
        setIsToggled(prevState => !prevState);
    };

    const generateAvatar = (initial) => {
        const svg = `
        <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100">
            <rect width="100%" height="100%" fill="#02176D" />
            <text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" font-size="40" fill="#fff" font-family="Arial">
                ${initial}
            </text>
        </svg>`;
        return `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
    };

    const getFirstInitial = (firstName) => {
        return firstName?.charAt(0)?.toUpperCase() || "E";
    };

    const profilePictureUrl = profileData?.firstName
        ? generateAvatar(getFirstInitial(profileData.firstName))
        : generateAvatar("E");

    return (
        <div> {profileData && <div>
            <header id="header" className="header fixed-top d-flex align-items-center" style={{ direction: "ltr" }}>

                <div className="d-flex align-items-center justify-content-between">
                    <a href="/dashboard" className="logo d-flex align-items-center">
                        <img 
                            src="assets/img/Car Chemist Logo-Main.svg" 
                            alt="Logo" 
                            style={{ height: '30px' }} 
                        />
                    </a>
                    <i className="bi bi-list toggle-sidebar-btn" onClick={handleToggleSidebar}></i>
                </div>

                <div className="search-bar">
                    <form className="search-form d-flex align-items-center" method="POST" action="#">
                        <input type="text" name="query" placeholder="Search" title="Enter search keyword"></input>
                        <button type="submit" title="Search"><i className="bi bi-search"></i></button>
                    </form>
                </div>

                <nav className="header-nav ms-auto">
                    <ul className="d-flex align-items-center">

                        <li className="nav-item d-block d-lg-none">
                            <a className="nav-link nav-icon search-bar-toggle " href="#">
                                <i className="bi bi-search"></i>
                            </a>
                        </li>

                        <li className="nav-item dropdown">
                            <a className="nav-link nav-icon" href="#" data-bs-toggle="dropdown">
                                <i className="bi bi-bell"></i>
                                <span className="badge bg-primary badge-number">0</span>
                            </a>

                            <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow notifications">
                                <li className="dropdown-header">
                                    You have 0 new notifications
                                </li>
                            </ul>
                        </li>

                        <li className="nav-item dropdown pe-3">
                            <a className="nav-link nav-profile d-flex align-items-center pe-0" href="#" data-bs-toggle="dropdown">
                                <img src={profilePictureUrl} alt="Profile" className="rounded-circle" />
                                <span className="d-none d-md-block dropdown-toggle ps-2">
                                    {profileData?.firstName || "Employee"}
                                </span>
                            </a>

                            <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow profile">
                                <li className="dropdown-header">
                                    <h6>{profileData.firstName} {profileData.lastName}</h6>
                                    <span>{profileData.userRole}</span>
                                </li>
                                <li>
                                    <hr className="dropdown-divider"></hr>
                                </li>

                                <li>
                                    <a className="dropdown-item d-flex align-items-center" href="users-profile.html">
                                        <i className="bi bi-person"></i>
                                        <span>My Profile</span>
                                    </a>
                                </li>
                                <li>
                                    <hr className="dropdown-divider"></hr>
                                </li>

                                <li>
                                    <a className="dropdown-item d-flex align-items-center" href="#" onClick={handleSignout}>
                                        <i className="bi bi-box-arrow-right"></i>
                                        <span>Sign Out</span>
                                    </a>
                                </li>
                            </ul>
                        </li>

                    </ul>
                </nav>

            </header>
            <aside id="sidebar" className={`sidebar ${isRTL === false ? "start-0" : "end-0"}`} style={{ width: "250px" }}>

                <ul className="sidebar-nav" id="sidebar-nav">
                    <li className="nav-heading">Pages</li>

                    <li className="nav-item">
                        <a className="nav-link collapsed" href="/dashboard">
                            <i className="bi bi-info-circle"></i>
                            <span>{translations["dashboard"] || "Dashboard"}</span>
                        </a>
                    </li>

                    <li className="nav-item">
                        <a className="nav-link collapsed" href="/orders">
                            <i className="bi bi-card-list"></i>
                            <span>{translations["orders"] || "Orders"}</span>
                        </a>
                    </li>

                    <li className="nav-item">
                        <a className="nav-link collapsed" href="#" onClick={(e) => { e.preventDefault(); toggleLanguage(); }}>
                            <i className="bi bi-translate"></i>
                            <span>{language === 'en' ? 'Switch to Arabic' : 'Switch to English'}</span>
                        </a>
                    </li>

                </ul>

            </aside>
        </div>}</div>
    );
};

export default HeaderEmployee;
